import { useState, useMemo } from 'react';
import { motion } from 'framer-motion';
import { AuliLogo } from '@/components/AuliLogo';
import { AuliMaozinha } from '@/components/illustrations/brand/AuliMaozinha';

const LOADING_PHRASES = [
  "Preparando seu foguete...",
  "Organizando os livros da estante...",
  "Acendendo as luzes do palco...",
  "Aquecendo os motores da curiosidade...",
  "Conectando mentes brilhantes...",
  "Abrindo portais de conhecimento...",
  "Afinando os instrumentos...",
];

export const LoadingScreen = () => {
  const phrase = useMemo(() => 
    LOADING_PHRASES[Math.floor(Math.random() * LOADING_PHRASES.length)],
    []
  );

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        {/* Animated Mãozinha */}
        <motion.div
          animate={{ 
            y: [0, -12, 0], 
            rotate: [-5, 5, -5] 
          }}
          transition={{ 
            repeat: Infinity, 
            duration: 2, 
            ease: "easeInOut" 
          }}
        >
          <AuliMaozinha variant="paz" size="xl" />
        </motion.div>
        
        {/* Logo */}
        <AuliLogo className="h-10 w-auto mt-2" />
        
        {/* Motivational phrase */}
        <motion.p 
          className="font-rubik text-lg text-foreground text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          {phrase}
        </motion.p>
        
        {/* Subtitle */}
        <p className="text-sm text-muted-foreground">
          Estamos preparando tudo para você...
        </p>
        
        {/* Loading dots */}
        <div className="flex gap-1.5 mt-2">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className="w-2 h-2 rounded-full bg-primary"
              animate={{ 
                scale: [1, 1.3, 1],
                opacity: [0.5, 1, 0.5]
              }}
              transition={{ 
                repeat: Infinity, 
                duration: 1,
                delay: i * 0.2,
                ease: "easeInOut"
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
